import axios from 'axios';
import Vue from 'vue';

function createInstance(baseURL) {
  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${localStorage.token}`
    },
  });
}

const axiosInstance = createInstance(`${process.env.VUE_APP_SERVER_PATH}:${process.env.VUE_APP_SERVER_PORT}`);
// const productionInstance = createInstance('http://localhost:3000'); // will change later

const apiInstall = () => {
  Vue.prototype.$api = axiosInstance;
};

export {
  axiosInstance,
  apiInstall,
};
